import { Component, OnInit, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Builder } from 'path-shared/models/builder';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { RespostesTableComponent } from '../components/respostes-table/respostes-table.component';
import { RespostesFilter } from '../models/respostes-filter';
import { RespostesFilterComponent } from '../components/respostes-filter/respostes-filter.component';
import { RespostesEditorComponent } from '../components/respostes-editor/respostes-editor.component';


@Component({
  selector: 'app-respostes',
  templateUrl: './respostes.component.html',
  styleUrls: ['./respostes.component.scss']
})
export class RespostesPageComponent implements OnInit, AfterViewInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: RespostesFilter;
  somIdFoo: number;
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(RespostesTableComponent) respostesTable: RespostesTableComponent;

  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<RespostesTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.filterData = new RespostesFilter('codi', 'asc');
      if (data !== undefined) {
        this.dataDialog = data;
      }
    }

  ngOnInit(): void {
    this.auth.UserCanSeePage(this.auth.Pages.Respostes);
    this.respostesTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.respostesTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Respuestas'));
    }
  }

  edit() {
    const idSeleccionat: string = this.respostesTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(RespostesEditorComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.respostesTable.load(); }
    });
  }

  refresh() {
    this.respostesTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(RespostesFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.respostesTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: RespostesFilter) => {
      this.respostesTable.filter.set(filter);
      this.respostesTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.respostesTable.generateExcel();
  }

}
